<template>
  <div class="ad-setup-container">
    <AdDetailsBox ref="detailsRef" />
    <div class="content-row">
      <AdCreativeBox ref="creativeRef" />
    </div>
    <DestinationBox ref="destinationRef" />
    <div class="footer">
      <button class="btn back" @click="$emit('prev')">Back</button>
      <button class="btn publish" @click="uploadvid">Review & Publish</button>
    </div>
    <div v-if="errors.length" class="error-messages">
      <p
        v-for="(e, i) in errors"
        :key="i"
        class="error-text"
        style="color: red"
      >
        ⚠ {{ e }}
      </p>
    </div>
    <v-dialog v-model="confirmDeleteDialog" max-width="500px" persistent>
      <v-card class="pa-6" style="border-radius: 16px">
        <!-- Close Icon -->
        <v-btn
          icon
          class="ma-0 pa-0 elevation-0"
          style="position: absolute; top: 12px; right: 12px"
          @click="confirmDeleteDialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <!-- Trash Icon + Title + Subtext -->
        <div class="px-2">
          <div
            class="d-flex align-center justify-center mb-4"
            style="
              width: 64px;
              height: 64px;
              background-color: #ffeaea;
              border-radius: 50%;
            "
          >
            <v-icon size="36" color="red">mdi-trash-can-outline</v-icon>
          </div>
          <h3 class="text-h6 font-weight-bold mb-1">
            Are you sure you want to delete this video
          </h3>
          <p class="text-body-2" style="color: #777">
            If you deleted this video you won’t be able to restore it again
          </p>
        </div>

        <!-- Buttons -->
        <div class="d-flex ga-4 mt-6 justify-space-between">
          <v-btn
            variant="outlined"
            class="text-body-2 font-weight-medium cancel-btn2"
            color="grey darken-1"
            style="border-radius: 10px"
            @click="canceldelete"
          >
            Cancel
          </v-btn>
          <v-btn
            class="text-body-2 font-weight-medium delete-btn2 elevation-0"
            color="red"
            style="border-radius: 10px"
            @click="goreview"
          >
            Delete
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="upresult" max-width="600px" persistent>
      <v-card class="rounded-lg pa-4" style="border-radius: 16px">
        <!-- Title -->
        <div class="d-flex justify-space-between align-center mb-4">
          <h3 class="text-h6 font-weight-bold">Video Upload Issue Detected</h3>
          <v-btn icon size="small" variant="text" @click="upresult = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Red banner (failed platforms) -->
        <div
          class="d-flex align-center pa-3 mb-4"
          style="background-color: rgba(255, 229, 229, 0.8); border-radius: 8px"
        >
          <svg
            width="24"
            height="21"
            viewBox="0 0 24 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.9998 8.00021V12.0002M11.9998 16.0002H12.0098M10.2898 2.8602L1.81978 17.0002C1.64514 17.3026 1.55274 17.6455 1.55177 17.9947C1.55079 18.3439 1.64127 18.6873 1.8142 18.9907C1.98714 19.2941 2.2365 19.547 2.53748 19.7241C2.83847 19.9012 3.18058 19.9964 3.52978 20.0002H20.4698C20.819 19.9964 21.1611 19.9012 21.4621 19.7241C21.7631 19.547 22.0124 19.2941 22.1854 18.9907C22.3583 18.6873 22.4488 18.3439 22.4478 17.9947C22.4468 17.6455 22.3544 17.3026 22.1798 17.0002L13.7098 2.8602C13.5315 2.56631 13.2805 2.32332 12.981 2.15469C12.6814 1.98605 12.3435 1.89746 11.9998 1.89746C11.656 1.89746 11.3181 1.98605 11.0186 2.15469C10.7191 2.32332 10.468 2.56631 10.2898 2.8602Z"
              stroke="#FF6666"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="text-body-2 ml-2 d-flex ga-2 align-center flex-wrap">
            <span style="color: #4d4d4d"
              >The video you uploaded is not compatible with</span
            >
            <template
              v-for="(msg, platform) in failedPlatforms"
              :key="platform"
            >
              <v-avatar size="20" class="mx-1">
                <img :src="getIconPath(platform)" :alt="platform + ' icon'" />
              </v-avatar>
              <strong class="mr-2" style="color: #0866ff">{{
                platform.toUpperCase()
              }}</strong>
            </template>
          </span>
        </div>

        <!-- Rejected & Accepted -->
        <div
          class="d-flex align-center mb-4"
          style="gap: 20px; flex-wrap: wrap"
        >
          <!-- Rejected -->
          <div
            class="d-flex align-center"
            style="
              background: #f2f2f2;
              border-radius: 20px;
              height: 32px;
              padding: 0 12px;
              box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
            "
          >
            <v-icon size="18" color="#F44336" class="me-1"
              >mdi-close-circle</v-icon
            >
            <span class="text-body-2 font-weight-medium me-2">Rejected</span>
            <template
              v-for="(msg, platform) in failedPlatforms"
              :key="platform"
            >
              <v-avatar size="20" class="me-1">
                <img :src="getIconPath(platform)" :alt="platform + ' icon'" />
              </v-avatar>
            </template>
          </div>

          <!-- Accepted -->
          <div
            class="d-flex align-center"
            style="
              background: #f2f2f2;
              border-radius: 20px;
              height: 32px;
              padding: 0 12px;
              box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
            "
          >
            <v-icon size="18" color="#4CAF50" class="me-1"
              >mdi-check-circle</v-icon
            >
            <span class="text-body-2 font-weight-medium me-2">Accepted</span>
            <template
              v-for="(data, platform) in successPlatforms"
              :key="platform"
            >
              <v-avatar size="20" class="me-1">
                <img :src="getIconPath(platform)" :alt="platform + ' icon'" />
              </v-avatar>
            </template>
          </div>
        </div>

        <!-- Reason -->
        <div class="mb-4">
          <p class="font-weight-bold mb-1">Video Rejection Reason:</p>
          <div
            v-for="(msg, platform) in failedPlatforms"
            :key="platform"
            class="text-body-2"
          >
            <strong
              >{{ platform ? platform.toUpperCase() : "UNKNOWN" }}:</strong
            >
            {{ msg || "Unknown error" }}
          </div>
        </div>

        <!-- Suggestion Alert Box -->
        <div
          class="pa-4 mb-4 text-body-2 d-flex justify-space-between"
          style="background-color: #f2f2f2; border-radius: 8px; color: #333"
        >
          <v-icon size="20" class="me-2" color="#237276"
            >mdi-information-outline</v-icon
          >
          <span>
            You can either upload a new video that meets Rejected platform
            requirements or remove Rejected from this campaign and proceed with
            the remaining platforms. Your original video will still be used for
            platforms that accepted it, so you won’t lose any of your work.
          </span>
        </div>

        <!-- Buttons -->
        <v-card-actions class="d-flex ga-2 justify-space-between">
          <v-btn variant="text" class="cancel-btn" @click="upresult = false"
            >CANCEL</v-btn
          >
          <div class="d-flex ga-2">
            <v-btn variant="outlined" class="remove-btn" @click="removeMeta"
              >Remove Rejected Campaign</v-btn
            >
            <v-btn class="reubload-btn" @click="reupload"
              >Reupload For Rejected</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AdDetailsBox from "@/components/SuperApp/StepTree/AdDetailsBox.vue";
import AdCreativeBox from "@/components/SuperApp/StepTree/AdCreativeBox.vue";
import DestinationBox from "@/components/SuperApp/StepTree/DestinationBox.vue";
import { useSuperAddStore } from "@/store/superAddStore";
import { useGeneralStore } from "@/store/General.js";

export default {
  name: "AdsStep",
  components: {
    AdDetailsBox,
    AdCreativeBox,
    DestinationBox,
  },
  data() {
    return {
      store: useSuperAddStore(),
      errors: [],
      resultDialog: false,
      successPlatforms: {},
      failedPlatforms: {},
      upresult: false,
      confirmDeleteDialog: false,
    };
  },
  computed: {
    superAdd() {
      return useSuperAddStore();
    },
    successItems() {
      return Object.entries(this.superAdd.succupload || {});
    },
    failedItems() {
      return this.superAdd.failupload || [];
    },
  },
  methods: {
    canceldelete() {
      this.confirmDeleteDialog = false;
      this.upresult = true;
    },
    removeMeta() {
      this.confirmDeleteDialog = true;
    },
    goreview() {
      this.$emit("submit");
    },
    async handleCreateAd() {
      const result = await this.store.createSuperAd();
      this.successPlatforms = result.success;
      this.failedPlatforms = result.failed;
      this.resultDialog = true;
    },
    submitAdStep() {
      this.$emit("submit");
    },
    getIconPath(platform) {
      return require(`@/components/SuperApp/ReviewPageIcon/${platform}.svg`);
    },
    reupload() {
      console.log("reupload logic");
    },
    removeRejected() {
      console.log("remove rejected platforms logic");
    },

    async uploadvid() {
      const generalStore = useGeneralStore(); // ✅ جلب GeneralStore
      this.errors = [];

      // 🧪 فاليديشن
      const detailsErrors = this.$refs.detailsRef.validate?.() || [];
      const creativeErrors = this.$refs.creativeRef.validate?.() || [];
      const destinationErrors = this.$refs.destinationRef.showForm
        ? this.$refs.destinationRef.validate?.() || []
        : [];

      this.errors = [...detailsErrors, ...creativeErrors, ...destinationErrors];

      if (this.errors.length > 0) {
        console.warn("Ad Step Validation Errors:", this.errors);
        return; // ⛔ فيه أخطاء، بنوقف هنا
      }

      const data = {
        ...this.$refs.detailsRef.getData?.(),
        ...this.$refs.creativeRef.getData?.(),
        ...(this.$refs.destinationRef.showForm
          ? this.$refs.destinationRef.getData?.()
          : {}),
      };

      console.log("✅ Final Ad Step Payload", data);

      try {
        generalStore.ShowLoading(); // ✅ إظهار اللودر

        const result = await this.store.uploadMedia();

        this.successPlatforms = result?.data?.success || {};

        const failedArray = result?.data?.failed || [];

        this.failedPlatforms = failedArray.reduce((acc, item) => {
          acc[item.platform] = item.message;
          return acc;
        }, {});

        if (Object.keys(this.failedPlatforms).length > 0) {
          this.upresult = true; // ❌ في فشل
        } else {
          this.$emit("submit"); // ✅ إرسال ناجح
        }
      } catch (error) {
        console.error("❌ Upload error:", error);
      } finally {
        generalStore.HideLoading(); // ✅ إخفاء اللودر دايمًا
      }
    },
    getIconPath(platform) {
      const icons = {
        facebook: require("@/components/SuperApp/ReviewPageIcon/facebook.svg"),
        tiktok: require("@/components/SuperApp/ReviewPageIcon/tiktok.svg"),
        snapchat: require("@/components/SuperApp/ReviewPageIcon/snap.svg"),
        meta: require("@/components/SuperApp/ReviewPageIcon/meta.svg"),
      };
      return icons[platform] || icons.meta;
    },
  },
};
</script>

<style scoped>
.ad-setup-container {
  padding: 0 2rem;
  max-width: 1200px;
  margin: auto;
}

.content-row {
  display: flex;
  gap: 1.5rem;
  margin-top: 2rem;
  flex-wrap: wrap;
  align-items: flex-start;
}

.footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;
  gap: 1rem;
}

.btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.btn.back {
  background-color: #f0f0f0;
  color: #333;
}

.btn.publish {
  background-color: #207878;
  color: #fff;
}
.v-alert {
  font-size: 14px;
}
.reubload-btn {
  background-color: #237276;
  color: #fff;
  border-radius: 8px;
  text-transform: capitalize;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px; /* assuming "Label Large/Size" maps to 14px */
  line-height: 20px;
  letter-spacing: 0.1px;
  vertical-align: middle;
}
.remove-btn {
  border: 1px solid #237276;
  color: #237276;
  text-transform: capitalize;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px; /* assuming "Label Large/Size" maps to 14px */
  line-height: 20px;
  letter-spacing: 0.1px;
  vertical-align: middle;
}
.cancel-btn {
  background-color: #f2f2f2;
  color: #4d4d4d;
  border-radius: 8px;
  text-transform: capitalize;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px; /* assuming "Label Large/Size" maps to 14px */
  line-height: 20px;
  letter-spacing: 0.1px;
  vertical-align: middle;
}
.cancel-btn2 {
  border-radius: 10px;
  width: 45%;
  color: #414651 !important;
}
.delete-btn2 {
  border-radius: 10px;
  width: 45%;
  background-color: #cc0000 !important;
}
</style>
